export default "__VITE_ASSET__5e84b03e__"